<template>
  <div class="pl-2 pr-2 pt-0 pb-0">
    <v-layout align-end justify-space-between>
      <div>
        <v-btn class="mt-2 mb-3" small color="warning" @click="openFilterDialog()">
          <v-icon>filter_list</v-icon>{{ $tt('customTaskFilterSetting') }}
        </v-btn>
        <div>
          {{ $tt('customTaskFilterCurrent') }}：<span class="font-weight-bold">{{ filterName }}</span>
        </div>
      </div>
      <v-layout justify-end align-end class="ml-2">
        <export-dialog :exportMode="exportMode" :selectFilter="selectFilter" />
      </v-layout>
    </v-layout>
    <!-- フィルターダイアログ -->
    <v-dialog v-model="dialogFilter" persistent max-width="800">
      <v-card class="pl-2 pr-2">
        <v-card-text>
          <!-- 日付フィルター -->
          <v-row class="pt-6" v-if="!hasFreeFunctionality()">
            <h2>{{ $tt('customTaskFilterDialogTitle1') }}</h2>
          </v-row>
          <v-row class="pt-4" v-if="!hasFreeFunctionality()">
            <v-col cols="3" class="mt-0">{{ $tt('customDateFilterCalendarType') }} </v-col>
            <v-col cols="3" class="pa-0 mt-1">
              <v-radio-group class="pl-2 mt-0" v-model="selectPickerType" @change="selectedPickerType" row>
                <v-radio :label="$tt('customDateFilterCalendarTypeMonth')" value="month"></v-radio>
                <v-radio :label="$tt('customDateFilterCalendarTypeDate')" value="date"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="!hasFreeFunctionality()">
            <v-col cols="12" lg="6" class="pt-0">
              <v-menu
                ref="menuDateFilterFrom"
                :close-on-content-click="false"
                :return-value.sync="filterDateFrom"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filterDateFrom"
                    :label="$tt('customDateFilterStartDate')"
                    readonly
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterDateFrom"
                  @change="saveDateFilterFrom"
                  no-title
                  :type="selectPickerType"
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
              <v-menu
                ref="menuDateFilterTo"
                :close-on-content-click="false"
                :return-value.sync="filterDateTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filterDateTo"
                    :label="$tt('customDateFilterEndDate')"
                    readonly
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterDateTo"
                  @change="saveDateFilterTo"
                  no-title
                  :type="selectPickerType"
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <!-- フィルター -->
          <v-row class="pt-6">
            <h2>{{ $tt('customTaskFilterDialogTitle2') }}</h2>
          </v-row>
          <v-row class="pt-6 ml-1">
            <v-col class="col-6 pt-0 pb-0 mt-2 pl-0">
              <v-select
                class="body-2 pt-0"
                v-model="selectFilter"
                item-text="filterName"
                return-object
                hide-details
                solo
                :items="filterItems"
                :label="$tt('customFilter')"
              ></v-select>
            </v-col>
            <v-col class="col-1 pl-0 pr-1 pb-0">
              <v-btn fab small color="primary" :disabled="isUpdateBtn" @click="openUpdateFilterDialog()">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-1 pl-0 pr-0 pb-0">
              <v-btn fab small color="error" :disabled="isDeleteBtn" @click="dialogDeleteFilter = !dialogDeleteFilter">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                :value="filterDefaultFlg"
                v-model="filterDefaultFlg"
                :label="$tt('customTaskFilterMakeDefault')"
                hide-details
                :disabled="filterDefaultFlg"
                @change="updateDefaultFlg"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-btn text block color="blue darken-1 " class="font-weight-bold" @click="openCreateFilterDialog()">
                <span>{{ $tt('customTaskFilterCreateNew') }}</span>
              </v-btn>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0 pl-6 pr-6 pb-3">
          <v-spacer></v-spacer>

          <v-btn right color="secondary" class="secondary task-detail" @click="closeDateFilterDialog()">
            {{ $tt('customCancel') }}
          </v-btn>
          <v-btn right color="primary" class="primary task-detail" @click="setFilter">
            {{ $tt('customDateFilterSetBotton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 削除ダイアログ -->
    <v-dialog v-model="dialogDeleteFilter" max-width="290" persistent>
      <v-card>
        <v-card-title>
          {{ $tt('customTaskFilterDeleteMsg', { filtername: '' + filterName }) }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            right
            color="secondary"
            class="secondary task-detail"
            @click="dialogDeleteFilter = !dialogDeleteFilter"
            >{{ $tt('customCancel') }}</v-btn
          >
          <v-btn right color="primary" @click="deleteFilter()" class="primary task-detail">
            {{ $tt('customDelete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- フィルター登録・更新ダイアログ -->
    <v-dialog v-model="dialogCreateFilter" persistent>
      <v-card>
        <v-card-text>
          <v-row class="pt-6">
            <h2 v-if="isFilterEditing">{{ $tt('customTaskFilterEdit') }}</h2>
            <h2 v-else>{{ $tt('customTaskFilterCreateNew') }}</h2>
          </v-row>
          <v-row class="pb-0">
            <v-col cols="6">
              <v-text-field :label="$tt('customTaskFilterName')" hide-details v-model="createFilterText"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pt-0 pb-3">
            <v-col>
              <v-btn outlined block color="blue darken-1" class="font-weight-bold" @click="sheetAccountUuids = true">
                <span>{{ $tt('customConnectionTitle') }}</span>
                <v-chip small color="blue darken-1" class="ml-1 white--text">{{ selectedAccountUuids.length }}</v-chip>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                outlined
                block
                color="brown darken-1"
                class="font-weight-bold"
                @click="sheetFieldGeoInfoKeys = true"
                :disabled="selectedAccountUuids.length === 0"
              >
                <span>{{ $tt('DocFormTabNameFieldList') }}</span>
                <v-chip
                  small
                  color="brown darken-1"
                  class="ml-1 white--text"
                  :disabled="selectedAccountUuids.length === 0"
                >
                  {{ selectedFields.length }}
                </v-chip>
              </v-btn>
            </v-col>
            <!--            <v-col>-->
            <!--              <v-btn-->
            <!--                outlined-->
            <!--                block-->
            <!--                color="light-green darken-1"-->
            <!--                class="font-weight-bold"-->
            <!--                @click="sheetCropIds = true"-->
            <!--                :disabled="selectedAccountUuids.length === 0"-->
            <!--              >-->
            <!--                <span>{{ $tt('customProduct') }}</span>-->
            <!--                <v-chip-->
            <!--                  small-->
            <!--                  color="light-green darken-1"-->
            <!--                  class="ml-1 white&#45;&#45;text"-->
            <!--                  :disabled="selectedAccountUuids.length === 0"-->
            <!--                >-->
            <!--                  {{ selectedCrops.length }}-->
            <!--                </v-chip>-->
            <!--              </v-btn>-->
            <!--            </v-col>-->
            <v-col>
              <v-btn
                outlined
                block
                color="blue-grey darken-1"
                class="font-weight-bold"
                @click="sheetOperationTypes = true"
              >
                <span>{{ $tt('customOperationType') }}</span>
                <v-chip small color="blue-grey darken-1" class="ml-1 white--text">{{
                  selectedOperationTypes.length
                }}</v-chip>
              </v-btn>
            </v-col>
          </v-row>
          <v-checkbox
            v-model="outOfFieldHiddenFlg"
            :label="$tt('customTaskFilterOutOfFieldHidden')"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="areaZeroHiddenFlg"
            :label="$tt('customTaskFilterAreaZeroHidden')"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="distanceUnderTenHiddenFlg"
            :label="$tt('customTaskFilterDistanceUnderTenHidden')"
            hide-details
          ></v-checkbox>
          <v-divider class="mt-4"></v-divider>
        </v-card-text>
        <v-card-actions class="pt-0 pr-6 pb-3">
          <v-spacer></v-spacer>
          <v-btn right color="secondary" class="secondary task-detail" @click="closeTaskFilterDialog()">
            {{ $tt('customCancel') }}
          </v-btn>
          <v-btn
            right
            color="primary"
            v-show="dispCreateBtn"
            class="primary task-detail"
            @click="createFilter"
            :disabled="isEmptyCreateFilterText"
          >
            {{ $tt('customRegistration') }}
          </v-btn>
          <v-btn
            right
            color="primary"
            v-show="dispUpdateBtn"
            class="primary task-detail"
            @click="updateFilter()"
            :disabled="isEmptyCreateFilterText"
          >
            {{ $tt('customUpdate') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Subscriptionフィルタ -->
    <v-bottom-sheet v-model="sheetAccountUuids">
      <v-sheet>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-switch
                v-model="accountsAllSelected"
                :label="accountsAllSelected ? $tt('customUnSelectAll') : $tt('customSelectAll')"
              ></v-switch>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$tt('customTaskFilterStringNarrowing')"
                v-model="filterStringAccountUuids"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-container style="max-height: 60vh" class="overflow-y-auto">
            <v-row justify="start">
              <v-checkbox
                :value="acc.username"
                v-model="selectedAccountUuids"
                hide-details
                class="ml-3"
                v-for="acc in accounts"
                :key="acc.username"
              >
                <template v-slot:label>
                  <user-icon-component size="20" :iconUrl="acc.iconUrl" />
                  {{ acc.nickname }}
                </template>
              </v-checkbox>
            </v-row>
          </v-container>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- 圃場フィルタ -->
    <v-bottom-sheet v-model="sheetFieldGeoInfoKeys">
      <v-sheet>
        <v-container>
          <v-row>
            <v-col cols="6" class="pb-0">
              <v-switch
                v-model="fieldsAllSelected"
                :label="fieldsAllSelected ? $tt('customUnSelectAll') : $tt('customSelectAll')"
              ></v-switch>
            </v-col>

            <v-col cols="6">
              <v-text-field
                :label="$tt('customTaskFilterStringNarrowing')"
                v-model="filterStringFieldGeoInfoKeys"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-container style="max-height: 60vh" class="overflow-y-auto">
            <v-row v-for="uff in userFiltersForSelectFields" :key="uff.username">
              <v-col cols="12" v-if="isSelectedAccount(uff.username)">
                <h4><user-icon-component class="mr-1" size="24" :iconUrl="uff.iconUrl" />{{ uff.nickname }}</h4>
                <v-row justify="start" v-if="uff.fields.length !== 0">
                  <v-checkbox
                    :value="field"
                    v-model="selectedFields"
                    :label="field.name"
                    hide-details
                    class="ml-3"
                    v-for="field in uff.fields"
                    :key="field.geoInfoKey"
                    multiple
                  />
                </v-row>
                <v-row v-else>
                  <div class="ml-3 mt-3">{{ $tt('customTaskFilterNoField') }}</div>
                </v-row>

                <v-divider class="mt-4" />
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- 作付けフィルタ -->
    <!--    <v-bottom-sheet v-model="sheetCropIds">-->
    <!--      <v-sheet>-->
    <!--        <v-container>-->
    <!--          <v-row>-->
    <!--            <v-col cols="6">-->
    <!--              <v-switch-->
    <!--                v-model="cropsAllSelected"-->
    <!--                :label="cropsAllSelected ? $tt('customUnSelectAll') : $tt('customSelectAll')"-->
    <!--              ></v-switch>-->
    <!--            </v-col>-->
    <!--            <v-col cols="6">-->
    <!--              <v-text-field-->
    <!--                :label="$tt('customTaskFilterStringNarrowing')"-->
    <!--                v-model="filterStringCropIds"-->
    <!--              ></v-text-field>-->
    <!--            </v-col>-->
    <!--          </v-row>-->
    <!--          <v-container style="max-height: 60vh" class="overflow-y-auto">-->
    <!--            <v-row v-for="ufc in userFiltersForSelectCrops" :key="ufc.username">-->
    <!--              <v-col cols="12" v-if="isSelectedAccount(ufc.username)">-->
    <!--                <h4><user-icon-component class="mr-1" size="24" :iconUrl="ufc.iconUrl" />{{ ufc.nickname }}</h4>-->
    <!--                <v-row justify="start" v-if="ufc.crops.length !== 0">-->
    <!--                  <v-checkbox-->
    <!--                    :value="crop"-->
    <!--                    v-model="selectedCrops"-->
    <!--                    hide-details-->
    <!--                    class="ml-3"-->
    <!--                    v-for="crop in ufc.crops"-->
    <!--                    :key="crop.id"-->
    <!--                    multiple-->
    <!--                  >-->
    <!--                    <template v-slot:label>-->
    <!--                      <product-indicator-component :product="wrapWithProduct(crop)" small="true" />-->
    <!--                    </template>-->
    <!--                  </v-checkbox>-->
    <!--                </v-row>-->
    <!--                <v-row v-else>-->
    <!--                  <div class="ml-3 mt-3">{{ $tt('customTaskFilterNoCrop') }}</div>-->
    <!--                </v-row>-->
    <!--                <v-divider class="mt-4" />-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--          </v-container>-->
    <!--        </v-container>-->
    <!--      </v-sheet>-->
    <!--    </v-bottom-sheet>-->

    <!-- 作業タイプフィルタ -->
    <v-bottom-sheet v-model="sheetOperationTypes">
      <v-sheet>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-switch
                v-model="operationTypesAllSelected"
                :label="operationTypesAllSelected ? $tt('customUnSelectAll') : $tt('customSelectAll')"
              ></v-switch>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$tt('customTaskFilterStringNarrowing')"
                v-model="filterStringOperationTypes"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-container style="max-height: 60vh" class="overflow-y-auto">
            <v-row justify="start">
              <v-checkbox
                :value="operationType.value"
                v-model="selectedOperationTypes"
                hide-details
                class="ml-3"
                v-for="operationType in availableOperationTypes"
                :key="operationType.id"
              >
                <template v-slot:label>
                  <operation-type-indicator-component :operationType="operationType.value" :displayBorder="false" />
                </template>
              </v-checkbox>
            </v-row>
          </v-container>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <now-loading-overlay-component :nowLoading="nowLoading" />
  </div>
</template>

<script>
import TaskFilterMixin from '@/components/mixins/task-filter-mixin'
import ExportDialog from '@/components/export/ExportDialog'
import OperationTypeIndicatorComponent from '@/components/operation/OperationTypeIndicatorComponent'
import ProductIndicatorComponent from '@/components/product/ProductIndicatorComponent'
import UserIconComponent from '@/components/user/UserIconComponent'
import NowLoadingOverlayComponent from '@/components/NowLoadingOverlayComponent'
import connectHttpBase from '@/lib/connect-client/connect-http-base'
import * as Constants from '@/lib/constants'
import Toast from '@/lib/toast'
import UserInfo from '@/lib/user-info'
import i18n from '@/lib/i18n'
import Serverless from '@/lib/serverless'
const convert = require('convert-units')

export default {
  name: 'TaskFilterComponent',
  components: {
    UserIconComponent,
    // ProductIndicatorComponent,
    OperationTypeIndicatorComponent,
    NowLoadingOverlayComponent,
    ExportDialog,
  },
  mixins: [TaskFilterMixin],

  props: {
    forCalendar: { type: Boolean, required: false, default: false },
  },

  data() {
    return {
      sheetAccountUuids: false,
      sheetFieldGeoInfoKeys: false,
      sheetCropIds: false,
      sheetOperationTypes: false,

      dialogCreateFilter: false,
      dialogDeleteFilter: false,
      dialogFilter: false,
      selectFilter: {
        filterName: '',
        defaultFlg: null,
        username: '',
        filterInfo: {
          areaZeroHiddenFlg: null,
          distanceUnderTenHiddenFlg: null,
          operationTypes: [],
          outOfFieldHiddenFlg: null,
          userFilters: [],
        },
      },
      filterItems: [],
      createFilterText: '',
      filterDefaultFlg: false,
      snackText: '',
      dispCreateBtn: false,
      dispUpdateBtn: false,
      isUpdateBtn: true,
      isDeleteBtn: true,
      nowLoading: false,
      isFilterEditing: false,
      filterName: '',

      exportMode: Constants.EXPORT_MODE.TASK_RECORDS,
      selectedFields: [],
      selectedCrops: [],
      isFilterSet: false,
    }
  },

  created() {
    this.toggleSelectedAccountUuids(true)
    this.toggleSelectedFieldGeoInfoKeys(true)
    // this.toggleSelectedCropIds(true)
    this.toggleSelectedOperationTypes(true)
  },
  mounted() {
    this.openNowLoading()
    this.loadDefaultFilter()
  },
  methods: {
    toBilling() {
      this.$router.push({ name: 'BillingBilling' })
    },
    closeTaskFilterDialog() {
      this.dialogCreateFilter = false
      if (this.isFilterEditing) {
        this.isFilterEditing = false
      }
    },
    setFilter() {
      this.openNowLoading()
      const dateWkFrom = new Date(this.utcStringOfDateFilterFrom())
      const dateWkTo = new Date(this.utcStringOfDateFilterTo())
      if (dateWkFrom.getTime() < dateWkTo.getTime()) {
        if (!this.forCalendar) {
          this.$emit('on-set-filter')
        }
        this.isFilterSet = true
        this.setDataFromSelectFilter(this.selectFilter)
        this.initTasksWithFilter()

        const params = {
          filterDateFrom: this.filterDateFrom,
          filterDateTo: this.filterDateTo,
          selectPickerType: this.selectPickerType,
        }
        this.$store.dispatch('setDateFilterRange', params)
        this.closeDateFilterDialog()
      } else {
        Toast.error(i18n.tt('customDateFilterRangeError'))
      }
      this.$store.dispatch('setCurrentFilter', this.selectFilter)
    },
    closeDateFilterDialog() {
      this.dialogFilter = false
    },
    selectedPickerType() {
      let dateWkFrom = new Date(this.filterDateFrom)
      let dateWkTo = new Date(this.filterDateTo)

      dateWkFrom = this.getEarlyMonth(dateWkFrom)
      dateWkTo = this.getEndOfMonth(dateWkTo)

      if (this.selectPickerType === Constants.DATE_PICKER_TYPE_MONTH) {
        dateWkFrom = this.toMonthString(dateWkFrom)
        dateWkTo = this.toMonthString(dateWkTo)
      } else {
        dateWkFrom = this.toDateString(dateWkFrom)
        dateWkTo = this.toDateString(dateWkTo)
      }
      this.filterDateFrom = dateWkFrom
      this.filterDateTo = dateWkTo
    },
    saveDateFilterFrom() {
      let dateWk = new Date(this.filterDateFrom)
      if (this.selectPickerType === Constants.DATE_PICKER_TYPE_MONTH) {
        dateWk = this.toMonthString(dateWk)
      } else {
        dateWk = this.toDateString(dateWk)
      }
      this.$refs.menuDateFilterFrom.save(dateWk)
    },
    saveDateFilterTo() {
      let dateWk = new Date(this.filterDateTo)
      if (this.selectPickerType === Constants.DATE_PICKER_TYPE_MONTH) {
        dateWk = this.toMonthString(dateWk)
      } else {
        dateWk = this.toDateString(dateWk)
      }
      this.$refs.menuDateFilterTo.save(dateWk)
    },
    openFilterDialog() {
      this.dialogFilter = true
      this.filterDefaultFlg = this.selectFilter.defaultFlg
    },
    async openCreateFilterDialog() {
      this.dispCreateBtn = true
      this.dispUpdateBtn = false
      this.createFilterText = ''
      this.selectedAccountUuids = []
      this.selectedFields = []
      this.selectedCrops = []
      await this.allFilterData.filterInfo.userFilters.forEach(uf => {
        this.selectedAccountUuids.push(uf.username)
        uf.fields.forEach(field => this.selectedFields.push(field))
        // uf.crops.forEach(crop => this.selectedCrops.push(crop))
      })
      this.selectedOperationTypes = this.listOperationTypes()
      this.areaZeroHiddenFlg = false
      this.distanceUnderTenHiddenFlg = false
      this.dialogCreateFilter = true
    },
    async openUpdateFilterDialog() {
      const check = this.filterNameCheck(this.selectFilter.filterName)
      if (!check) {
        this.snackText = i18n.tt('customTaskFilterSelectCheckError')
        Toast.error(this.snackText)
        return
      } else {
        this.selectedAccountUuids = []
        this.selectedFields = []
        this.selectedCrops = []
        await this.selectFilter.filterInfo.userFilters.forEach(suf => {
          const userFilter = this.allFilterData.filterInfo.userFilters.find(auf => auf.username === suf.username)
          if (userFilter) {
            this.selectedAccountUuids.push(suf.username)
            suf.fieldGeoInfoKeys.forEach(fgik => {
              const field = userFilter.fields.find(f => f.geoInfoKey === fgik)
              if (field) {
                this.selectedFields.push(field)
              }
            })
            // suf.cropIds.forEach(cid => {
            //   const crop = userFilter.crops.find(c => c.id === cid)
            //   if (crop) {
            //     this.selectedCrops.push(crop)
            //   }
            // })
          }
        })
        this.selectedOperationTypes = this.selectFilter.filterInfo.operationTypes
        this.areaZeroHiddenFlg = this.selectFilter.filterInfo.areaZeroHiddenFlg
        this.distanceUnderTenHiddenFlg = this.selectFilter.filterInfo.distanceUnderTenHiddenFlg
        this.outOfFieldHiddenFlg = this.selectFilter.filterInfo.outOfFieldHiddenFlg

        this.dispCreateBtn = false
        this.dispUpdateBtn = true
        this.createFilterText = this.selectFilter.filterName
        this.filterDefaultFlg = this.selectFilter.defaultFlg
        this.isFilterEditing = true
        this.dialogCreateFilter = true
      }
    },
    filterNameCheck(filterName) {
      let ret = false
      for (let filterItem of this.filterItems) {
        if (filterItem.filterName === filterName) {
          ret = true
        }
      }
      return ret
    },
    filterNameAndUuidCheck(filterName) {
      let ret = false
      for (let filterItem of this.filterItems) {
        if (filterItem.filterName === filterName) {
          if (filterItem.uuid !== this.selectFilter.uuid) {
            ret = true
          }
        }
      }
      return ret
    },
    async deleteFilter() {
      const check = this.filterNameCheck(this.selectFilter.filterName)
      if (!check) {
        this.snackText = i18n.tt('customTaskFilterSelectCheckError')
        Toast.error(this.snackText)
        return
      }
      this.snackText = i18n.tt('customTaskFilterDeleteSucceed')
      const retData = await Serverless.deleteFilterItem(this.myUsername, this.selectFilter.uuid)
      if (retData) {
        this.getFilter(Constants.TASK_FILTER_GET_MODE.DELETE, '')
        Toast.success(this.snackText)
        this.dialogDeleteFilter = false
      }
    },
    loadDefaultFilter() {
      if (this.storeFilterDateFrom !== '') {
        this.filterDateFrom = this.storeFilterDateFrom
      }
      if (this.storeFilterDateTo !== '') {
        this.filterDateTo = this.storeFilterDateTo
      }
      this.selectPickerType = this.storeSelectPickerType
      this.getFilter(Constants.TASK_FILTER_GET_MODE.FIRST_PROCESS, '')
    },
    async getFilter(loadMode, filterName) {
      const key = connectHttpBase.calclateSecretHash(this.myUsername)
      const retData = await Serverless.getFilterList(this.myUsername, key)
      if (retData) {
        let fieldGeoInfoKeys = []
        let cropIds = []
        let allData = {
          filterInfo: {
            userFilters: [],
            operationTypes: this.allFilterData.filterInfo.operationTypes,
            outOfFieldHiddenFlg: false,
            areaZeroHiddenFlg: false,
            distanceUnderTenHiddenFlg: false,
          },
          username: this.myUsername,
          filterName: i18n.tt('customTaskFilterAllSelect'),
          defaultFlg: false,
        }
        this.allFilterData.filterInfo.userFilters.forEach(auf => {
          let username = auf.username
          let fieldGeoInfoKeys = []
          let cropIds = []
          auf.fields.forEach(f => fieldGeoInfoKeys.push(f.geoInfoKey))
          // auf.crops.forEach(c => cropIds.push(c.id))
          allData.filterInfo.userFilters.push({
            username: username,
            fieldGeoInfoKeys: fieldGeoInfoKeys,
            cropIds: cropIds,
          })
        })

        this.filterItems = []
        this.filterItems.push(allData)
        for (let retDataItem of retData) {
          if (retDataItem.hasOwnProperty('filterInfo')) {
            this.filterItems.push(retDataItem)
          } else {
            this.filterItems.push(this.convertNewTaskFilter(retDataItem))
          }
        }
        if (
          loadMode === Constants.TASK_FILTER_GET_MODE.FIRST_PROCESS ||
          loadMode === Constants.TASK_FILTER_GET_MODE.DELETE
        ) {
          if (this.currentFilter) {
            this.selectFilter = this.currentFilter
          } else {
            if (this.isAllFalseDefaultFlg) {
              const index = this.filterItems.findIndex(
                filterItem => filterItem.filterName === i18n.tt('customTaskFilterAllSelect')
              )
              this.filterItems[index].defaultFlg = true
              this.selectFilter = this.filterItems[index]
            } else {
              for (let filterItem of this.filterItems) {
                if (filterItem.defaultFlg) {
                  this.selectFilter = filterItem
                  break
                }
              }
            }
          }
          this.setDataFromSelectFilter(this.selectFilter)
          this.initTasksWithFilter()
        }
        if (loadMode === Constants.TASK_FILTER_GET_MODE.CREATE) {
          for (let filterItem of this.filterItems) {
            if (filterName === filterItem.filterName) {
              this.selectFilter = filterItem
              break
            }
          }
          if (this.isAllFalseDefaultFlg) {
            const index = this.filterItems.findIndex(
              filterItem => filterItem.filterName === i18n.tt('customTaskFilterAllSelect')
            )
            this.filterItems[index].defaultFlg = true
          }
        }
      }
    },
    async updateDefaultFlg(newValue) {
      if (newValue) {
        this.openNowLoading()
        const key = connectHttpBase.calclateSecretHash(this.myUsername)
        let retData = undefined
        if (this.isSelectFilterForAllData) {
          for (let filterItem of this.filterItems) {
            if (filterItem.filterName === i18n.tt('customTaskFilterAllSelect')) {
              filterItem.defaultFlg = true
              continue
            }
            const modify = {
              Item: {
                uuid: filterItem.uuid,
                userName: this.myUsername,
                filterName: filterItem.filterName,
                defaultFlg: false,
                filterInfo: filterItem.filterInfo,
                key: key,
              },
            }
            retData = await Serverless.putFilterItem(this.myUsername, modify)
          }
        } else {
          const ret = await this.putDefaultFlg()
          if (ret === false) {
            Toast.error(i18n.tt('customTaskFilterPutError'))
            return
          }
          const modify = {
            Item: {
              uuid: this.selectFilter.uuid,
              userName: this.myUsername,
              filterName: this.selectFilter.filterName,
              defaultFlg: newValue,
              filterInfo: this.selectFilter.filterInfo,
              key: key,
            },
          }
          retData = await Serverless.putFilterItem(this.myUsername, modify)
        }
        if (retData) {
          await this.getFilter(Constants.TASK_FILTER_GET_MODE.CREATE, this.selectFilter.filterName)
          this.createFilterText = ''
          this.snackText = i18n.tt('customTaskFilterSetDefault', { filtername: '' + this.selectFilter.filterName })
          Toast.success(this.snackText)
        }
        this.closeNowLoading()
      }
    },
    async putDefaultFlg() {
      const key = connectHttpBase.calclateSecretHash(this.myUsername)
      let updateItem = []
      for (let filterItem of this.filterItems) {
        if (filterItem.filterName !== i18n.tt('customTaskFilterAllSelect')) {
          updateItem.push(filterItem)
        }
      }
      const modify = {
        Item: {
          userName: this.myUsername,
          filterItem: updateItem,
          key: key,
        },
      }
      const retData = await Serverless.putDefaultFlg(modify)
      if (retData) {
        return true
      }
      return false
    },
    async updateFilter() {
      this.openNowLoading()
      const check = this.filterNameAndUuidCheck(this.createFilterText)
      if (check) {
        this.snackText = i18n.tt('customTaskFilterDuplicateCheckError')
        this.closeNowLoading()
        Toast.error(this.snackText)
        return
      }
      if (this.createFilterText === '') {
        this.snackText = i18n.tt('customTaskFilterNotEnteredCheckError')
        this.closeNowLoading()
        Toast.error(this.snackText)
        return
      }
      this.snackText = i18n.tt('customTaskFilterPutSucceed', { filtername: '' + this.createFilterText })
      await this.putFilter()
      this.closeNowLoading()
      this.closeTaskFilterDialog()
    },
    createFilterInfo() {
      let filterInfo = {
        userFilters: [],
        outOfFieldHiddenFlg: this.outOfFieldHiddenFlg,
        operationTypes: this.selectedOperationTypes,
        areaZeroHiddenFlg: this.areaZeroHiddenFlg,
        distanceUnderTenHiddenFlg: this.distanceUnderTenHiddenFlg,
      }
      this.selectedAccountUuids.forEach(sau => {
        let username = sau
        let fieldGeoInfoKeys = []
        this.selectedFields.forEach(field => {
          if (username === field.username) {
            fieldGeoInfoKeys.push(field.geoInfoKey)
          }
        })
        let cropIds = []
        this.selectedCrops.forEach(crop => {
          if (username === crop.username) {
            cropIds.push(crop.id)
          }
        })
        const userFilter = {
          username: username,
          fieldGeoInfoKeys: fieldGeoInfoKeys,
          cropIds: cropIds,
        }
        filterInfo.userFilters.push(userFilter)
      })
      return filterInfo
    },
    async putFilter() {
      if (this.filterDefaultFlg && this.filterItems.length > 1) {
        const ret = await this.putDefaultFlg()
        if (ret === false) {
          Toast.error(i18n.tt('customTaskFilterPutError'))
          return
        }
      }
      const key = connectHttpBase.calclateSecretHash(this.myUsername)
      const filterInfo = this.createFilterInfo()

      const modify = {
        Item: {
          uuid: this.selectFilter.uuid,
          userName: this.myUsername,
          filterName: this.createFilterText,
          filterInfo: filterInfo,
          defaultFlg: this.selectFilter.defaultFlg,
          key: key,
        },
      }
      this.filterStringAccountUuids = ''
      this.filterStringFieldGeoInfoKeys = ''
      this.filterStringCropIds = ''
      this.filterStringOperationTypes = ''
      const retData = await Serverless.putFilterItem(this.myUsername, modify)
      if (retData) {
        await this.getFilter(Constants.TASK_FILTER_GET_MODE.CREATE, this.createFilterText)
        this.createFilterText = ''
        Toast.success(this.snackText)
      }
    },
    async createFilter() {
      this.openNowLoading()
      this.snackText = i18n.tt('customTaskFilterPostSucceed', { filtername: '' + this.createFilterText })
      const check = this.filterNameCheck(this.createFilterText)
      if (check) {
        this.snackText = i18n.tt('customTaskFilterDuplicateCheckError')
        Toast.error(this.snackText)
        return
      }
      if (this.createFilterText === '') {
        this.snackText = i18n.tt('customTaskFilterNotEnteredCheckError')
        Toast.error(this.snackText)
        return
      }
      await this.postFilter()
      this.closeNowLoading()
      this.closeTaskFilterDialog()
    },
    async postFilter() {
      const key = connectHttpBase.calclateSecretHash(this.myUsername)
      const filterInfo = this.createFilterInfo()
      const modify = {
        Item: {
          userName: this.myUsername,
          filterName: this.createFilterText,
          filterInfo: filterInfo,
          defaultFlg: false,
          key: key,
        },
      }
      this.filterStringAccountUuids = ''
      this.filterStringFieldGeoInfoKeys = ''
      this.filterStringCropIds = ''
      this.filterStringOperationTypes = ''
      const retData = await Serverless.postFilterItem(this.myUsername, modify)
      if (retData) {
        this.getFilter(Constants.TASK_FILTER_GET_MODE.CREATE, this.createFilterText)
        this.createFilterText = ''
        Toast.success(this.snackText)
      }
    },
    wrapWithProduct(crop) {
      return { crop: crop }
    },
    initTasksWithFilter() {
      const taskFilter = this.buildTaskFilter()
      taskFilter.filterName = this.selectFilter.filterName
      if (this.forCalendar) {
        const pagingOptions = {
          pageSize: 10000,
          page: 0,
        }
        this.$store.dispatch('initTasksWithFilter', {
          pagingOptions,
          taskFilter,
          onFinally: this.initTasksWithFilterOnFinally,
        })
      } else {
        const page = this.isFilterSet ? 0 : this.pagingOptions.page
        const pagingOptions = {
          pageSize: this.pagingOptions.pageSize,
          page: page,
          onFinally: this.initTasksWithFilterOnFinally,
        }
        this.$store.dispatch('updatePagingOfTaskList', {
          pagingOptions,
          taskFilter,
          onFinally: this.initTasksWithFilterOnFinally,
        })
      }
    },
    initTasksWithFilterOnFinally() {
      this.closeNowLoading()
    },
    hasFreeFunctionality() {
      return UserInfo.hasFreeFunctionality()
    },
    updatePagingOfTaskList(pagingOptions) {
      this.openNowLoading()
      const taskFilter = this.buildTaskFilter()
      this.$store.dispatch('updatePagingOfTaskList', {
        pagingOptions,
        taskFilter,
        onFinally: this.initTasksWithFilterOnFinally,
      })
    },
    closeNowLoading() {
      this.nowLoading = false
    },
    openNowLoading() {
      this.nowLoading = true
    },
    isSelectedAccount(uuid) {
      return this.selectedAccountUuids.some(sau => sau === uuid)
    },
  },

  computed: {
    tasks() {
      return this.$store.getters.tasks
    },
    products() {
      return this.$store.getters.products
    },
    currentFilter() {
      return this.$store.getters.currentFilter
    },
    isSelectFilterForAllData() {
      return this.selectFilter.filterName === i18n.tt('customTaskFilterAllSelect')
    },
    isAllFalseDefaultFlg() {
      // 「全ての作業」以外のフィルターのデフォルトフラグが全てfalseか
      return !this.filterItems.some(
        filterItem => filterItem.filterName !== i18n.tt('customTaskFilterAllSelect') && filterItem.defaultFlg
      )
    },
    pagingOptions() {
      const pageSize = this.$store.getters.pagingOptions.tasks.pageSize
      const page = this.$store.getters.pagingOptions.tasks.page
      return { pageSize: pageSize, page: page }
    },
    isEmptyCreateFilterText() {
      return !this.createFilterText
    },
    accounts() {
      if (!this.filterStringAccountUuids) {
        let accounts = []
        this.allFilterData.filterInfo.userFilters.forEach(uf =>
          accounts.push({ username: uf.username, nickname: uf.nickname, iconUrl: uf.iconUrl })
        )
        return accounts
      }
      return this.getAccountsTextFilter()
    },
    userFiltersForSelectFields() {
      if (!this.filterStringFieldGeoInfoKeys) {
        this.fieldsFilterFlg = false
        return this.allFilterData.filterInfo.userFilters
      }
      return this.getFieldsTextFilter()
    },
    userFiltersForSelectCrops() {
      if (!this.filterStringCropIds) {
        this.cropsFilterFlg = false
        return this.allFilterData.filterInfo.userFilters
      }

      return this.getCropsIdsTextFilter()
    },
    storeFilterDateFrom() {
      return this.$store.getters.filterDateFrom
    },
    storeFilterDateTo() {
      return this.$store.getters.filterDateTo
    },
    storeSelectPickerType() {
      return this.$store.getters.selectPickerType
    },
  },

  watch: {
    selectFilter: function(val, oldVal) {
      if (val.filterName === i18n.tt('customTaskFilterAllSelect')) {
        this.isUpdateBtn = true
        this.isDeleteBtn = true
      } else {
        this.isUpdateBtn = false
        this.isDeleteBtn = false
      }
      this.filterDefaultFlg = val.defaultFlg
    },

    selectedAccountUuids(val, oldVal) {
      if (!this.dialogCreateFilter) {
        return
      }
      const result = val.filter(v => oldVal.indexOf(v) === -1)
      let newSelectedFields = []
      let newSelectedCrops = []
      result.forEach(r => {
        const userFilter = this.allFilterData.filterInfo.userFilters.find(suf => r === suf.username)
        userFilter.fields.forEach(f => newSelectedFields.push(f))
        userFilter.crops.forEach(f => newSelectedCrops.push(f))
      })

      val.forEach(v => {
        this.selectedFields.forEach(field => {
          if (field.username === v) {
            newSelectedFields.push(field)
          }
        })
        this.selectedCrops.forEach(crop => {
          if (crop.username === v) {
            newSelectedCrops.push(crop)
          }
        })
      })

      this.selectedFields = newSelectedFields
      this.selectedCrops = newSelectedCrops
    },

    // AccountQuery
    accountsAllSelected: function(val, oldVal) {
      this.toggleSelectedAccountUuids(val)
    },

    // CropQuery
    cropsAllSelected: function(val, oldVal) {
      this.toggleSelectedCropIds(val)
    },

    // FieldQuery
    fieldsAllSelected: function(val, oldVal) {
      this.toggleSelectedFieldGeoInfoKeys(val)
    },

    // OperationTypeQuery
    operationTypesAllSelected: function(val, oldVal) {
      this.toggleSelectedOperationTypes(val)
    },
  },
}
</script>

<style scoped>
.export-type-select {
  margin: 10px;
}

.grey-text {
  color: grey;
}

.select-export-type-text {
  margin-top: 10px;
}

.selected-export-type {
  border: solid;
  border-width: 1px;
  border-color: red;
}

.free-plan-alert {
  margin: 20px;
}

.export-dialog-card {
  padding: 5px 5px 5px 5px;
}
.theme--light.v-messages {
  display: none !important;
}
</style>
